<template>
    <div class="box" id="contact">
        <div class="box__inner">
            <h2><span>4/4</span> {{ t('Données de contact')}}</h2>
        </div>
            <p v-translate>Votre adresse e-mail est utilisé pour la confirmation. Votre numéro de téléphone est utilisé comme moyen de contact pour votre réservation.</p>
        <div class="box__inner">
            <label for="telephone" v-translate>Télephone</label>
            <input v-on:input="addContactDetails" name="phone" v-model="phone" type="tel" id="telephone" placeholder="+352 123 456" required>
            <label for="email" v-translate>Adresse e-mail (optionnel)</label>
            <input v-on:input="addContactDetails" name="email" v-model="email" type="email" id="email" placeholder="email@example.lu">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ContactDetails',
        data: function() {
          return({
              phone: this.$store.state.phone,
              email: this.$store.state.email,
          })
        },
        methods: {
            addContactDetails() {
                this.$store.commit('changeData', {
                    type: 'phone',
                    value: this.phone
                });
                this.$store.commit('changeData', {
                    type: 'email',
                    value: this.email
                });
            }
        }
    }

</script>

<style scoped>
    .box {
        background-color: var(--green--light);
        border-radius: 4px;
        color: var(--green--dark);
        margin-top: 200px;
        margin-bottom: 120px;
        padding: var(--xxlarge) var(--xmedium);
    }

    @media only screen and (max-width: 500px) {
        .box {
            margin-top: 100px;
            margin-bottom: 60px;
            padding: var(--xlarge) var(--medium);
        }
    }

    .box__inner {
        margin: 0 auto;
        max-width: 690px;
    }

    h2 {
        font-size: 50px;
        color: var(--green--dark);
        margin-top: 0;
        text-align: center;
    }

    h2 span {
        display: block;
        font-family: gill-sans-nova, sans-serif;
        font-weight: 700;
        font-size: 24px;
        margin-bottom: 15px;
    }

    @media only screen and (max-width: 500px) {
        h2 span {
            display: block;
            margin-bottom: 10px;
        }
    }

    p {
        color: var(--green--dark);
        font-size: 21px;
        margin: 0 auto var(--xmedium);
        max-width: 850px;
        text-align: center;
    }

    label {
        display: block;
        font-size: 18px;
        margin: 15px 0 5px;
    }

    input {
        border-radius: 4px;
        border: none;
        padding: 8px var(--medium);
        width: 100%;
    }

    input::placeholder {
        opacity: 0.6;
    }


</style>
